import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CommonTable from '../../CommonTable/CommonTable';
import TableAction from '../../CommonTable/TableAction';
import CustomPagination from '../../CustomPagination/CustomPagination';

import { deletePopularLocation, updateLocationStatus } from '../../../actions/siteadmin/deletePopularLocation';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';
import { dynamicLocationValue } from '../../../helpers/GetDynamicItemName/dynamicHomeValue';

import cs from '../../../components/commonStyle.css';
import s from './PopularLocationManagement.css';
import messages from '../../../locale/jsonMessages';
function PopularLocationManagement(props) {

  const { loading, data, currentPage, searchList, setStateVariable, updateLocationStatus, deletePopularLocation, refetch, demoRestriction } = props;
  const { formatMessage, locale } = props.intl;
  const handleSearchChange = (searchList) => {
    let variables = {
      currentPage: 1,
      searchList,
    };
    setStateVariable({ searchList, currentPage: 1 });
    refetch(variables);
  }

  const paginationData = (currentPage) => {
    let variables = { currentPage };
    setStateVariable({ currentPage, searchList });
    refetch(variables);
  }

  const handleDeleteLocation = async (id) => {
    let variables = { currentPage: currentPage > 1 && data?.results?.length == 1 ? currentPage - 1 : currentPage, searchList };
    const isRestrict = await demoRestriction({ restrictType: 'popularLocation', restrictValue: id });
    if (isRestrict) return;
    setStateVariable({ currentPage: variables.currentPage, searchList });
    await deletePopularLocation(id, currentPage);
    refetch(variables);
  }

  const handleLocationStatus = async (id, isEnable) => {
    const isRestrict = await demoRestriction({ restrictType: 'popularLocation', restrictValue: id });
    if (isRestrict) return;
    await updateLocationStatus(id, isEnable);
    refetch();
  }

  const thead = () => {
    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.location) },
      { data: formatMessage(messages.locationAddress) },
      { data: formatMessage(messages.status) },
      { data: formatMessage(messages.setEnableDisable) },
    ]
  }

  const tbody = () => {
    return data?.results?.map(value => {
      const location = dynamicLocationValue(value, locale).location
      return {
        id: value?.id,
        data: [
          { data: value?.id, },
          {
            data: <div className={cx(cs.displayFlex, cs.alignCenter, cs.spaceBetween)}>
              {location}
              <TableAction
                onClickDelete={() => handleDeleteLocation(value?.id)}
                showDelete={true}
                showEdit={true}
                editLink={"/siteadmin/edit/popularlocation/" + value.id}
              />
            </div>
          },
          { data: value?.locationAddress },
          { data: value.isEnable == 'true' ? formatMessage(messages.enabledLabel) : formatMessage(messages.disabledLabel) },
          {
            data: <div><a href="javascript:void(0)" onClick={() => handleLocationStatus(value?.id, value?.isEnable)} >
              {value.isEnable == 'true' ? formatMessage(messages.disableLabel) : formatMessage(messages.enableLabel)}
            </a></div>
          },
        ]
      }
    })
  }

  return (
    <div>
      <CommonTable
        thead={thead}
        isSearch
        onSearch={(e) => handleSearchChange(e?.target?.value)}
        tbody={() => tbody()}
        title={formatMessage(messages.managePopularLocations)}
        isLink
        href={`/siteadmin/popularlocation/add`}
        redirectionLabel={formatMessage(messages.addPopularLocation)}
      />
      {
        data?.count > 0 &&
        <CustomPagination
          total={data?.count}
          currentPage={currentPage}
          defaultCurrent={1}
          defaultPageSize={10}
          change={paginationData}
          paginationLabel={formatMessage(messages.locationsLabel)}
        />
      }
    </div>
  );
}

const mapState = (state) => ({});

const mapDispatch = {
  deletePopularLocation,
  updateLocationStatus,
  demoRestriction
};

PopularLocationManagement.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      location: PropTypes.string,
      locationAddress: PropTypes.string,
      isEnable: PropTypes.string,
      images: PropTypes.string,
    })),
  }),
  deletePopularLocation: PropTypes.any,
  updateLocationStatus: PropTypes.any,
};



PopularLocationManagement.defaultProps = {
  data: {},
};


export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(PopularLocationManagement)));